module.exports = __webpack_public_path__ + "static/media/employer_help_hire.e1a64a93.png";